import { INav } from "./services/Router"
import { UsersPage } from "./view/pages/UsersPage"

import { CardsPage } from "./view/pages/CardsPage"
import { DashboardPage } from "./view/pages/DashboarPage"

import { TeamsPage } from "./view/pages/TeamsPage"
import { TransactionsPage } from "./view/pages/TransactionsPage"

import { GD } from "src/GD"
import { USER_ROLE } from "src/services/AuthService"
import { type ReactNode, useMemo } from "react"
import { TeamDetailsPage } from "./view/pages/TeamDetailsPage"
import { ReferralPage } from "./view/pages/ReferralPage"

const MenuIcon = ({ children }: { children: ReactNode }) => (
	<svg width='20' height='20' viewBox='0 0 24 24' fill='none' aria-hidden='true'>
		{children}
	</svg>
)

const menuIconStroke = {
	stroke: "currentColor",
	strokeWidth: 1.9,
	strokeLinecap: "round" as const,
	strokeLinejoin: "round" as const
}

const IconMenuDashboard = () => (
	<MenuIcon>
		<path d='M4 13.5C4 8.8 7.8 5 12 5s8 3.8 8 8.5' {...menuIconStroke} />
		<path d='M5.5 18h13' {...menuIconStroke} />
		<path d='M12 13l3.2-3.2' {...menuIconStroke} />
		<circle cx='12' cy='13' r='1.6' fill='currentColor' />
	</MenuIcon>
)

const IconMenuUsers = () => (
	<MenuIcon>
		<path d='M9.5 11a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z' {...menuIconStroke} />
		<path d='M4 19c.6-3 2.8-4.7 5.5-4.7s4.9 1.7 5.5 4.7' {...menuIconStroke} />
		<path d='M16.2 11.3a2.6 2.6 0 0 0 0-5' {...menuIconStroke} />
		<path d='M17 14.6c1.8.6 3 2 3.5 4.4' {...menuIconStroke} />
	</MenuIcon>
)

const IconMenuTeams = () => (
	<MenuIcon>
		<path d='M7 8.5h10' {...menuIconStroke} />
		<path d='M12 8.5V15' {...menuIconStroke} />
		<rect x='4' y='5' width='6' height='5' rx='1.5' {...menuIconStroke} />
		<rect x='14' y='5' width='6' height='5' rx='1.5' {...menuIconStroke} />
		<rect x='9' y='15' width='6' height='5' rx='1.5' {...menuIconStroke} />
	</MenuIcon>
)

const IconMenuTransactions = () => (
	<MenuIcon>
		<path d='M7 7h10l-2.2-2.2' {...menuIconStroke} />
		<path d='M17 17H7l2.2 2.2' {...menuIconStroke} />
		<path d='M17 7l-2.2 2.2' {...menuIconStroke} />
		<path d='M7 17l2.2-2.2' {...menuIconStroke} />
	</MenuIcon>
)

const IconMenuCards = () => (
	<MenuIcon>
		<rect x='3.5' y='6' width='17' height='12' rx='2.2' {...menuIconStroke} />
		<path d='M3.5 10h17' {...menuIconStroke} />
		<path d='M7 14.5h4' {...menuIconStroke} />
	</MenuIcon>
)

const IconMenuReferral = () => (
	<MenuIcon>
		<path d='M4 12h16v8H4z' {...menuIconStroke} />
		<path d='M12 12v8M3 8h18v4H3zM12 8H7.5a2 2 0 1 1 2-2c0 1.4 2.5 2 2.5 2ZM12 8h4.5a2 2 0 1 0-2-2c0 1.4-2.5 2-2.5 2Z' {...menuIconStroke} />
	</MenuIcon>
)

const _sitemap: INav[] = [
	{
		path: "/",
		label: "Dashboard",
		id: "dashboard",
		roles: [USER_ROLE.ADMIN, USER_ROLE.TEAM_LEAD, USER_ROLE.BUYER],
		icon: <IconMenuDashboard />,
		page: <DashboardPage />
	},
	{
		path: "users",
		label: "Users",
		roles: [USER_ROLE.ADMIN, USER_ROLE.TEAM_LEAD],
		id: "users",
		icon: <IconMenuUsers />,
		page: <UsersPage />
	},
	{
		path: "teams",
		label: "Teams",
		roles: [USER_ROLE.ADMIN, USER_ROLE.TEAM_LEAD],
		id: "teams",
		icon: <IconMenuTeams />,
		page: <TeamsPage />,
		sub: [
			{
				path: ":teamId",
				id: "team_details",
				label: "Team Details",
				roles: [USER_ROLE.ADMIN, USER_ROLE.TEAM_LEAD],
				page: <TeamDetailsPage />
			}
		]
	},
	{
		path: "transactions",
		label: "Transactions",
		roles: [USER_ROLE.ADMIN, USER_ROLE.TEAM_LEAD, USER_ROLE.BUYER],
		id: "transactions",
		icon: <IconMenuTransactions />,
		page: <TransactionsPage />
	},

	{
		path: "cards",
		label: "Cards",
		roles: [USER_ROLE.ADMIN, USER_ROLE.BUYER],
		id: "cards",
		icon: <IconMenuCards />,
		page: <CardsPage />
	},
	{
		path: "referral",
		label: "Referrals",
		roles: [USER_ROLE.ADMIN],
		id: "referral",
		icon: <IconMenuReferral />,
		page: <ReferralPage />
	}
	// {
	// 	path: "cardholders",
	// 	label: "Card Holders",
	// 	roles: ["admin"],
	// 	id: "cardholders",
	// 	icon: <IconAcquirers size="24" />,
	// 	page: <CardHoldersPage />,
	// },
	// {
	// 	path: "accounts",
	// 	label: "Accounts",
	// 	roles: ["admin"],
	// 	id: "accounts",
	// 	icon: <IconAccountant size="24" />,
	// 	page: <AccountsPage />,
	// },
	// {
	// 	path: "agents",
	// 	label: "Agents",
	// 	roles: ["admin"],
	// 	id: "agents",
	// 	icon: <IconKey />,
	// 	page: <AgentsPage />,
	// },
	// {
	// 	path: "campaigns",
	// 	label: "Campaigns",
	// 	roles: ["admin"],
	// 	id: "campaigns",
	// 	icon: <IconProgress />,
	// 	page: <CampaignsPage />,
	// },
	// {
	// 	path: "payouts",
	// 	label: "Payouts",
	// 	roles: ["admin"],
	// 	id: "payouts",
	// 	icon: <IconCapitalInvestment size="24" />,
	// 	page: <PayoutsPage />,
	// },
] as const

export interface IMenu {
	label: string
	id: string
	type: string
	icon?: JSX.Element
}

export const useMenu = () => {
	const [user] = GD.REQ_PROFILE.useRequest()

	const res: IMenu[] | null = useMemo(() => {
		if (!user) return null

		const userRole = user.company_role as USER_ROLE
		const _menu: IMenu[] = []

		for (const i of _sitemap) {
			if (i.roles && (i.roles as string[]).includes(userRole)) {
				_menu.push({
					label: i.label,
					id: i.id,
					icon: i.icon,
					type: i.path.startsWith("$") ? i.path.substring(1) : "item"
				})
			}
		}
		return _menu
	}, [user])

	return res || []
}

export const sitemap = (): INav[] => _sitemap.filter((val) => !val.path.startsWith("$"))
